module.exports = "\nvarying vec3 f_normal;\nvarying vec3 f_position;\n\nvoid main() {\n    f_normal = normal;\n    f_position = position;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/vert.glsl
// module id = 12
// module chunks = 0